import React, { useEffect, useState } from 'react'
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Controller, useForm } from "react-hook-form";
import { Dialog } from 'primereact/dialog';
import { JVInput } from '../../shared/JVInput';
import { Button } from 'primereact/button';
import { InputTextarea } from 'primereact/inputtextarea';
import { JVDropdown } from '../../shared/JVDropdown';
import { Fetch } from '../../shared/Fetch';

interface IProps {
    singleData: IAssignmentForm,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void
}

export interface IAssignmentForm {
    id?: number,
    assignment_Name: string,
    assignment_Descriptions: string,
    department: string,
    status?:boolean
}
export const emptyForm: IAssignmentForm = {
    assignment_Name: "",
    assignment_Descriptions: '',
    department: '',
}
const schema = yup.object().shape({
    assignment_Name: yup.string().required('Assignment Name required'),
    assignment_Descriptions: yup.string().required('Assignment Description  required'),
    department: yup.string().required('Department required'),
})

const roles = [{ name: "Recruiter" }, { name: "Sales" }]

export const Form = (props: IProps) => {
    const { control, handleSubmit, formState: { errors }, reset } = useForm<IAssignmentForm>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });

    const onSubmit = async (data: IAssignmentForm) => {
        console.log(data)
        const method = props.singleData?.id ? "PUT" : "POST";
        const message = props.singleData?.id ? "Updated Successfully" : "Added Successfully";
        const response = await Fetch("Assignment_Mast", method, data, null, props.toast)
        if (response) {
            props.hideDialog();
            props.setReload(!props.reload);
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
        }
    }

    const onHide = () => {
        props.hideDialog();
        reset(emptyForm);
    }

    useEffect(() => {
        reset(props.singleData);
    }, [props.open]);

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit Assignment Question" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVInput column={3} required label='Assignment Name' name='assignment_Name' control={control} error={errors.assignment_Name?.message} />
                <JVDropdown column={3} name='department' label='Department' control={control} options={roles} optionValue='name' optionLabel='name' placeholder='-- Select Role --' error={errors.department?.message}></JVDropdown>
              <div className="field col-12 md:col-12 mt-0">
                    <label htmlFor="assignment_Descriptions"> Assignment Description<span style={{ color: 'red' }}>*</span> </label>
                    <Controller name="assignment_Descriptions" control={control} render={({ field }) => (
                        <InputTextarea {...field} rows={5} cols={20} />
                    )} />
                    {errors.assignment_Descriptions && <p className="p-error">{errors.assignment_Descriptions.message}</p>}
                </div>
                <div className="col-12 md:col-12 flex gap-4">
                    <Button className="field col md:col" label="SAVE" type="submit" ></Button>
                    <Button className="field col md:col p-button-outlined" label="CLOSE" onClick={onHide} type="button"></Button>
                </div>
            </form>
        </Dialog>
    )
}
